/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown>, amount: NonNullable<unknown> }} Plan_Changed_ChargedInputs */

const en_plan_changed_charged = /** @type {(inputs: Plan_Changed_ChargedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switched to ${i?.plan}. ${i?.amount} charged today.`)
};

const es_plan_changed_charged = /** @type {(inputs: Plan_Changed_ChargedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambiaste a ${i?.plan}. Se cobraron ${i?.amount} hoy.`)
};

/**
* | output |
* | --- |
* | "Switched to {plan}. {amount} charged today." |
*
* @param {Plan_Changed_ChargedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_changed_charged = /** @type {((inputs: Plan_Changed_ChargedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Changed_ChargedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_changed_charged(inputs)
	return en_plan_changed_charged(inputs)
});